module.exports = __webpack_public_path__ + "img/light-ceiling.8dcf9769.svg";